export default __webpack_public_path__ + "static/twitter-9f13d6fce2ec4b2bdbe1626a2808d3e2.mp4";